import { getTokenDefinition, } from "@bracket/chainography";
import { wagmiConfig as config, } from "@wagmiconfig";
import { bi, } from "@utils";

import { deposit as depositV1, } from "@bracket/contractor-next/bracket-vault";
import { deposit as depositV2, } from "@bracket/contractor-next/bracket-vault-v2";


import type {
	AmountString,
	TokenIdentifier,
	BlockHash,
	VaultAddress,
} from "@bracket/types";  

import type { LoadedVault, } from "@types";


export declare type InvestProps = {
	vault: LoadedVault;
  amount: AmountString;
  token: TokenIdentifier;
}



export declare type InvestResult = {
	success: true;
  hash: BlockHash;
} | {
	success: false;
  rejected: true;
} | {
	success: false;
  rejected: false;
  error: Error;
}



export const invest = async ({
  vault,
  amount,
  token,
}: InvestProps ): Promise<InvestResult> => {

	try {

		const tok = getTokenDefinition(token);
		const { address, chain: { id: chainId, }, version, } = vault;
		const deposit = version === null ? depositV1 : depositV2;

		const hash = await deposit({
			vault: address as VaultAddress,
			amount: bi(amount, tok),
			token: tok,
			chainId,
			config,
		});

		return {
			success: true,
			hash,
		}
	
	} catch (err) {

		if(err instanceof Error && err.message.toLowerCase().includes("user rejected")) {
      return {	
        success: false,
        rejected: true,
      }
    }

		return {
			success: false,
			rejected: false,
			error: err as Error,
		}

	}

}